import { render, staticRenderFns } from "./CaseRequirement.vue?vue&type=template&id=e5c3d840&scoped=true"
import script from "./CaseRequirement.vue?vue&type=script&lang=js"
export * from "./CaseRequirement.vue?vue&type=script&lang=js"
import style0 from "./CaseRequirement.vue?vue&type=style&index=0&id=e5c3d840&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c3d840",
  null
  
)

export default component.exports